import { ToastType } from "../classes";

export const openWindowWithUrl = (url: string) => window?.open(url, "_blank");

export const openProductPlan =
  (
    invalid: boolean,
    showToast: (
      toast_type: ToastType,
      toast_text: string,
      btn_label: string,
      onBtnClick: () => void
    ) => void
  ) =>
  () => {
    if (invalid) {
      return showToast(
        ToastType.info,
        "데스크톱에서 이용할 수 있어요.\nPC로 접속해 주세요.",
        "닫기",
        () => {}
      );
    }
    window?.open("https://app.potoo.ai/payment/plan", "_blank");
  };
